/**
 * Sidebar Popover
 *
 * Handles sidebar toggle using the popover API.
 * Syncs expanded state with popover visibility.
 */

const SELECTORS = {
	sidebar: ".sidebar",
	toggle: ".sidebar-toggle",
	searchInput: ".search-input",
};

/**
 * Initialize sidebar popover behavior.
 */
function init() {
	const sidebar = document.querySelector(SELECTORS.sidebar) as HTMLElement;
	const toggle = document.querySelector(SELECTORS.toggle) as HTMLElement;

	if (!sidebar || !toggle) {
		return;
	}

	const mediaQuery = window.matchMedia("(max-width: 768px)");

	function handleBreakpointChange(e) {
		if (e.matches) {
			sidebar.setAttribute("popover", "auto");
		} else {
			sidebar.removeAttribute("popover");
		}
	}

	// Initial check
	handleBreakpointChange(mediaQuery);

	// Listen for changes
	mediaQuery.addEventListener("change", handleBreakpointChange);

	// Sync aria-expanded when popover toggles
	sidebar.addEventListener("toggle", (event: ToggleEvent) => {
		const expanded = event.newState === "open";
		toggle.setAttribute("aria-expanded", String(expanded));

		if (expanded) {
			const searchInput = sidebar.querySelector(
				SELECTORS.searchInput,
			) as HTMLInputElement;
			if (searchInput) {
				searchInput.focus();
			}
		}
	});

	// Handle Ctrl+K to open sidebar on mobile
	document.addEventListener("keydown", (e) => {
		if ((e.ctrlKey || e.metaKey) && e.key === "k") {
			if (
				sidebar.hasAttribute("popover") &&
				!sidebar.matches(":popover-open")
			) {
				e.preventDefault();
				sidebar.showPopover();
			}
		}
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
